"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericJson = void 0;
var zod_1 = require("zod");
var literalSchema = zod_1.z.union([zod_1.z.string(), zod_1.z.number(), zod_1.z.boolean(), zod_1.z.null()]);
exports.GenericJson = zod_1.z.lazy(function () {
    return zod_1.z.union([literalSchema, zod_1.z.array(exports.GenericJson), zod_1.z.record(exports.GenericJson)]);
});
